export const CREATED = 'CREATED';
export const ASSIGNED = 'ASSIGNED';
export const PROGRESS = 'PROGRESS';
export const ARRIVAL = 'ARRIVAL';
export const COMPLETED = 'COMPLETED';
export const CANCELED = 'CANCELED';
